import React from 'react';
import { TrendingDownIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
export function RoiLeak() {
  return <section id="roi-leak" aria-labelledby="roi-leak-title" className="border-b border-white/5 bg-ink-900" data-id="element-258" data-mp="1yfckpievreaa">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-259" data-mp="23c2yfz37pxsj">
        <Reveal className="max-w-3xl" data-id="element-260" data-mp="285xgky3664pi">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-261" data-mp="2d3zayf61pqga">
            <TrendingDownIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-262" data-mp="2i20u103h1prr" />
          </span>
          <p className="mt-6 text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-263" data-mp="2m45kxr2jc8ap">
            The gap
          </p>
          <h2 id="roi-leak-title" className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-264" data-mp="2r275yhjiuhot">
            The ROI leak.
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-265" data-mp="wppmll1t01pg">
            <p data-id="element-266" data-mp="1xu6emojj6suh">
              Add up what you spent on leads and tech last year. Portals, CRM, dialer,
              texting tool. Six figures for a lot of teams. Now count the closings that
              came from it.
            </p>
            <p data-id="element-267" data-mp="1k171uub4vcqm">
              The gap between those two numbers lives in the follow-up layer, and it is
              fixable without buying one more lead.
            </p>
          </div>
          <p className="mt-6 border-l-2 border-brand pl-5 font-display text-lg leading-relaxed text-white/85 sm:text-xl" data-id="element-268" data-mp="2gp4yo3qshq0k">
            Same budget, worked properly, more closings.
          </p>
        </Reveal>
      </div>
    </section>;
}